<a href="#" class="restore-chat w-100 align-self-center" title="{{{o.tooltip}}}">
    {[ if (o.num_unread) { ]} 
        <span class="message-count badge badge-light">{{{o.num_unread}}}</span>
    {[ } ]}
    {{{o.title || o.jid }}}
</a>
<a class="chatbox-btn close-chatbox-button fa fa-sign-out-alt"></a>
